import React, { useRef } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Formik } from 'formik';
import 'jspdf-autotable';
import MaterialTable from "material-table";
import { useEffect, useState } from 'react';
import { useAlert } from "react-alert";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { trackPromise } from 'react-promise-tracker';
import { useNavigate } from 'react-router-dom';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import * as Yup from "yup";
import { LoadingComponent } from '../../../utils/newLoader';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import services from '../Services';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  }
}));

const screenCode = 'SUPPLIERSKUMAPPING';
export default function SupplierSKUMappingListing() {
  const classes = useStyles();
  const alert = useAlert();
  const navigate = useNavigate();
  const [groupArray, setGroupArray] = useState([]);
  const [factories, setFactories] = useState();
  const componentRef = useRef();
  const [suppliersAuto, setSuppliersAuto] = useState([]);
  const [budgetCodes, setBudgetCodes] = useState();
  const [skuCategory, setSKUCategory] = useState();
  const [SupplierSKUMappingData, setSupplierSKUMappingData] = useState([]);
  const [formData, setFormdata] = useState({
    groupID: 0,
    factoryID: 0,
    supplierID: 0,
    budgetcodeID: 0,
    skuCategoryID: 0
  })

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
  });

  const [selectedOptions, setSelectedOptions] = useState([]);
  const handleClick = () => {
    navigate('/app/SupplierSkuMapping/addEdit');
  }

  const valuesArray = selectedOptions.map(option => option.value);
  useEffect(() => {
    setFormdata({ ...formData, skuMasterID: valuesArray })
  }, [selectedOptions]);

  useEffect(() => {
    trackPromise(
      getPermission()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getGroupsForDropdown()
    );
  }, [])

  useEffect(() => {
    trackPromise(
      getFactoriesByGroupID()
    )
  }, [formData.groupID]);


  useEffect(() => {
    if (formData.groupID > 0) {
      trackPromise(
        getBudgetCodesForDropDown(),
      );
    };
    setSKUCategory([]);
    setSelectedOptions([]);
    setFormdata({
      ...formData,
      supplierID: 0,
      budgetcodeID: 0,
      skuCategoryID: 0,
      skuMasterID: [],
    });
  }, [formData.groupID]);

  useEffect(() => {
    if (formData.groupID != 0 && formData.factoryID != 0) {
      trackPromise(
        getSkuCategoryForDropDown(formData.groupID, formData.factoryID, formData.budgetcodeID)
      );
    } else {
      setFormdata(prev => ({
        ...prev,
        skUCategoryID: 0
      }));
      setSKUCategory([]);
    }
  }, [formData.groupID, formData.factoryID, formData.budgetcodeID])

  useEffect(() => {
    if (formData.factoryID !== 0) {
      trackPromise(getSuppliersForDropDownAuto());
    }
  }, [formData.factoryID]);


  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUPPLIERSKUMAPPING');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setFormdata({
      ...formData,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupArray(groups);
  }

  async function getFactoriesByGroupID() {
    const fac = await services.getFactoriesByGroupID(formData.groupID);
    setFactories(fac);
  }

  async function getSuppliersForDropDownAuto() {
    const supplierResult = await services.getSuppliersForDropDownAuto(
      formData.factoryID
    );
    setSuppliersAuto(supplierResult);
  }

  async function getBudgetCodesForDropDown() {
    const budgetCode = await services.GetBudgetCodeForDropdown();
    setBudgetCodes(budgetCode);
  }

  async function getSkuCategoryForDropDown() {
    const SKUCategoryNames = await services.GetSKUCategoryNamesByID(formData.budgetcodeID, formData.groupID, formData.factoryID);
    setSKUCategory(SKUCategoryNames);
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    if (name === "groupID") {
      setFormdata({
        groupID: parseInt(value),
        factoryID: 0,
        supplierID: 0,
        budgetcodeID: 0,
        skuCategoryID: 0,
      });
      setSKUCategory([]);
      setSelectedOptions([]);
      setSupplierSKUMappingData([]);
    } else if (name === "budgetcodeID") {
      setFormdata({
        ...formData,
        budgetcodeID: parseInt(value),
        skuCategoryID: 0,
      });
      setSKUCategory([]);
      setSelectedOptions([]);
      setSupplierSKUMappingData([]);
    } else if (name === "skuCategoryID") {
      setFormdata({
        ...formData,
        skuCategoryID: parseInt(value),
      });
      setSelectedOptions([]);
      setSupplierSKUMappingData([]);
    } else {
      setFormdata({
        ...formData,
        [name]: parseInt(value)
      });
      setSupplierSKUMappingData([]);
    }
  }
  function handleSearchDropdownChangeFieldsSupplier(data, e) {
    if (data === undefined || data === null) {
      setFormdata({
        ...formData,
        supplierID: '0'
      });
      return;
    } else {
      var valueV = data["supplierID"];
      setFormdata({
        ...formData,
        supplierID: valueV
      });
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  async function getData() {
    let model = {
      groupID: formData.groupID || 0,
      supplierID: formData.supplierID || 0,
      budgetcodeID: formData.budgetcodeID || 0,
      skuCategoryID: formData.skuCategoryID || 0,
      factoryID: formData.factoryID || 0
    };
    const response = await services.getMappingDetailsForListing(model);
    getSelectedDropdownValuesForReport(formData.groupID, formData.factoryID)
    if (response.statusCode == 'Success') {
      setSupplierSKUMappingData(response.data);
    } else {
      alert.error(response.message);
      setSupplierSKUMappingData([]);
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>

          <PageHeader
            onClick={handleClick}
            isEdit={true}
            toolTiptitle={"Add Supplier SKU Mapping Details"}
          />

        </Grid>
      </Grid>
    )
  }

  function getSelectedDropdownValuesForReport(groupID, factoryID) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: groupArray[groupID],
      factoryName: factories[factoryID],
    })
  }
  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
        }
   
        body {
            background-color: white !important;
        }
    }`;
  };
  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Supplier Name': x.supplierName,
          'Account Code Name': x.budgetCodeName,
          'SKU Category Name': x.skuCategoryName,
          'SKU Name': x.skuMasterName,
        }
        res.push(vr);
      });

      res.push({});
      var date = new Date().toLocaleString().split(',')[0];
      var vr = {
        'Supplier Name': "Group: " + selectedSearchValues.groupName,
        'Account Code Name': "Factory: " + selectedSearchValues.factoryName,
        'Suplier Name': "Report Generated Date: " + date,
      }
      res.push(vr);
    }
    return res;
  }
  async function createFile() {

    var file = await createDataForExcel(SupplierSKUMappingData);
    var settings = {
      sheetName: 'Supplier SKU Mapping',
      fileName: 'Supplier SKU Mapping - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + new Date().toLocaleString().split(',')[0],
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = [];
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'SKU Mapping Details',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  return (
    <Page className={classes.root} title="Supplier SKU Mapping View">
      <LoadingComponent />
      <Container maxWidth={false}>
        <Formik
          initialValues={{
            groupID: formData.groupID,
            factoryID: formData.factoryID,
            supplierID: formData.supplierID,
            budgetcodeID: formData.budgetcodeID,
            skuCategoryID: formData.skuCategoryID,
          }}
          validationSchema={Yup.object().shape({
            groupID: Yup.number().required('Group required').min(1, 'Group required'),
            factoryID: Yup.number().required('Factory required').min(1, 'Factory required')
          })}
          onSubmit={getData}
          enableReinitialize
        >
          {({ errors, handleSubmit, touched }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={0}>
                <Card>
                  <CardHeader title={cardTitle("Supplier SKU Mapping View")} />
                  <PerfectScrollbar>
                    <Divider />
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(touched.groupID && errors.groupID)}
                            helperText={touched.groupID && errors.groupID}
                            fullWidth
                            name="groupID"
                            size="small"
                            onChange={handleChange}
                            value={formData.groupID}
                            variant="outlined"
                            InputProps={{
                              readOnly: !permissionList.isGroupFilterEnabled,
                            }}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(groupArray)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="factoryID">Factory *</InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            helperText={touched.factoryID && errors.factoryID}
                            fullWidth
                            size='small'
                            name="factoryID"
                            onChange={(e) => handleChange(e)}
                            value={formData.factoryID}
                            variant="outlined"
                            id="factoryID"
                            InputProps={{
                              readOnly: !permissionList.isFactoryFilterEnabled ? true : false
                            }}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="supplierID">
                            Supplier
                          </InputLabel>
                          <Autocomplete
                            id="supplierID"
                            options={suppliersAuto || []}
                            getOptionLabel={(option) => option?.supplierName || "Unnamed Supplier"}
                            onChange={(e, value) => handleSearchDropdownChangeFieldsSupplier(value, e)}
                            value={
                              suppliersAuto?.find(
                                (option) => option.supplierID === formData.supplierID
                              ) || null
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                name="supplierID"
                                fullWidth
                                size="small"
                                placeholder="--Select Supplier--"
                                error={Boolean(touched.supplierID && errors.supplierID)}
                                helperText={touched.supplierID && errors.supplierID}

                              />
                            )}
                          />
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="budgetcodeID">
                            Account Code Name
                          </InputLabel>
                          <TextField
                            select
                            fullWidth
                            name="budgetcodeID"
                            size="small"
                            onChange={handleChange}
                            value={formData.budgetcodeID}
                            variant="outlined"
                            InputProps={{
                              readOnly: !permissionList.isFactoryFilterEnabled,
                            }}
                          ><MenuItem value="0">--Select Account Code Name--</MenuItem>
                            {generateDropDownMenu(budgetCodes)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="skuCategoryID">
                            SKU Category
                          </InputLabel>
                          <TextField
                            select
                            fullWidth
                            name="skuCategoryID"
                            size="small"
                            onChange={handleChange}
                            value={formData.skuCategoryID}
                            variant="outlined"
                          >
                            <MenuItem value="0">--Select SKU Category--</MenuItem>
                            {generateDropDownMenu(skuCategory)}
                          </TextField>
                        </Grid>
                      </Grid>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button color="primary" type="submit" variant="contained">
                          Search
                        </Button>
                      </Box>
                    </CardContent>
                    <Box minWidth={1050}>
                      {SupplierSKUMappingData.length > 0 ?
                        <MaterialTable
                          title="Multiple Actions Preview"
                          columns={[
                            { title: 'Supplier Name', field: 'supplierName' },
                            { title: 'Account Code Name', field: 'budgetCodeName' },
                            { title: 'SKU Category Name', field: 'skuCategoryName' },
                            { title: 'SKU Name', field: 'skuMasterName' },
                          ]}
                          data={SupplierSKUMappingData}
                          options={{
                            exportButton: false,
                            showTitle: false,
                            headerStyle: { textAlign: "left", height: '1%' },
                            cellStyle: { textAlign: "left" },
                            columnResizable: false,
                            actionsColumnIndex: -1,
                            pageSize: 10
                          }}
                          actions={[

                          ]}
                        /> : null}
                    </Box>
                    {SupplierSKUMappingData.length > 0 && (
                      <CardContent>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={" Supplier SKU Mapping " + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + new Date().toLocaleString().split(',')[0]}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              SupplierSKUMappingData={SupplierSKUMappingData} searchData={selectedSearchValues}
                              Date={new Date().toLocaleString().split(',')[0]}
                            />
                          </div>
                        </Box>

                      </CardContent>
                    )}
                  </PerfectScrollbar>
                </Card>
              </Box>
            </form>
          )}
        </Formik>
      </Container>
    </Page>
  );
}
